<template>
  <div>
    <!-- TABS//S -->
    <div class="tab-design">
      <ul>
        <li><router-link to="/notice">공지사항</router-link></li>
        <li><router-link to="/event">이벤트</router-link></li>
      </ul>
    </div>
    <!-- TABS//E -->
    <!-- NOTICE VIEW//S -->
    <div class="board-view">
      <!-- 상세보기// S-->
      <div class="board-top">
        <div class="clearfix">
          <h3 class="pull-left">{{tableData.title}}</h3>
        </div>
        <div class="text-right">
          <span class="date">{{tableData.regDate}}</span>
        </div>
        <div class="text-left" v-html="tableData.contents">
        </div>
      </div>
      <!-- 상세보기// E-->
      <!-- 하단// S-->
      <div class="board-bottom">
        <dl class="dl-horizontal">
          <dt>다음글<i class="material-icons">arrow_drop_up</i></dt>
          <dd>
            <router-link :to="noticeNext.link" v-if="noticeNext.nextTitle">
              {{noticeNext.nextTitle}}
            </router-link>
            <span v-else>다음글이 없습니다.</span>
          </dd>
        </dl>
        <dl class="dl-horizontal">
          <dt>이전글<i class="material-icons">arrow_drop_down</i></dt>
          <dd>
            <router-link :to="noticePrev.link" v-if="noticePrev.preTitle">
              {{noticePrev.preTitle}}
            </router-link>
            <span v-else>이전글이 없습니다.</span>
          </dd>
        </dl>
      </div>
      <!-- 하단// E-->
      
    </div>
    <div class="text-right">
      <vs-button color="#717171" onclick="window.location.href='/notice'" class="btn-gray btn-wide">목록</vs-button>
    </div>
    <!-- NOTICE VIEW//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
export default {
  data() {
    return {
      actives:0,
      tableData: {
        id:'',
        title: '',
        regDate: '',
        contents: ''
      },
      noticeNext: {
        nextTitle: '',
        link: ''
      },
      noticePrev: {
        preTitle: '',
        link: ''
      }
    };
  },
  mounted() {
    this.getNoticeView()
  },
  methods: {
    getNoticeView() {
      const params = {
        itemId: this.$route.params.id
      }
      Api.Board.getItems(params)
     .then(response => {
        const data = response.body;

        const { id, title, regDate, contents, nextId, nextTitle, preId, preTitle } = response.body;

        this.tableData = {
          id, title, contents, regDate
        }

        this.noticeNext = {
          nextTitle,
          link: `/notice/view/${nextId}`
        }

        this.noticePrev = {
          preTitle,
          link: `/notice/view/${preId}`
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.getNoticeView();
  }
  
};
</script>
<style>
</style>
